import {faUsers} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {dateFormatFR} from '../../../utils';
import DataTable from '../../../common/components/Datatable/Datatable';
import Screen from '../../../common/components/layout/Screen';
import Metadata from '../../../common/components/Metadata';
import {Span} from '../../../common/components/StyledComp';
import {FILTER_EXPRESSION_OPERATOR, FILTER_OPERATOR} from '../../../common/constants';
import AddCentralPurchasing from './AddCentralPurchasing';
import CentralPurchasingRowAction from './CentralPurchasingRowAction';


const GRAPHQL_QUERY_CENTRAL_PURCHASING = gql`
  query centralsPurchasing($criteria: CriteriaInput!) {
    centralsPurchasing(criteria: $criteria) {
      id
      total
      rows{
        id
        brand{
          id
          name
          file{
            id
            token
          }
        }
        user{
          id
          firstName
          lastName
          isActive
          isDeleted
          street
          postalCode
          city
        }
        contactEmail
        contactName
        siret
        createdAt
        updatedAt
      }
    }
  }
`;

const displayAction = ({cell}) => <CentralPurchasingRowAction {...cell.value}/>;

const columns = t => [
  {
    Header: '#',
    accessor: 'id',
    sortable: true,
  },
  {
    Header: t('brand'),
    accessor: 'brand.name',
    sortable: true,
  },
  {
    Header: t('firstName'),
    accessor: 'user.firstName',
    sortable: true,
  },
  {
    Header: t('lastName'),
    accessor: 'user.lastName',
    sortable: true,
  },
  {
    Header: t('email'),
    accessor: 'contactEmail',
    sortable: true,
  },
  {
    Header: t('creation'),
    Cell: ({cell}) => dateFormatFR({date: cell.value}),
    accessor: 'createdAt',
    sortable: true,
  },
  {
    Header: t('details'),
    Cell: displayAction,
    accessor: row => row,
  },
];

const initialFilters = null;

const CentralsListView = ({t}) => {
  const [advancedFilters, setAdvancedFilters] = React.useState(initialFilters);

  const onSearch = search => setAdvancedFilters({
    operator: FILTER_EXPRESSION_OPERATOR.Or,
    filters: [{
      field: 'centralPurchasing.id',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'user.firstName',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'user.lastName',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'contactEmail',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'brand.name',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }],
    relations: ['user', 'brand'],
  });

  return (
    <Screen
      header={<Metadata title={t('title')} meta={t('meta')}/>}
      leftTitle={
        <>
          <FontAwesomeIcon icon={faUsers} color={'rgb(201,0,95)'}/>
          <Span className="route-name">{t('datatable.title')}</Span>
        </>
      }
      rightTitle={<AddCentralPurchasing/>}>
      <DataTable
        query={GRAPHQL_QUERY_CENTRAL_PURCHASING}
        columns={columns(t)}
        keyResult="centralsPurchasing"
        defaultSort={{field: 'createdAt'}}
        advancedFilters={advancedFilters}
        onSearch={onSearch}/>
    </Screen>
  );
};

CentralsListView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('centralPurchasing')(CentralsListView);
